import { defineMessages } from '../i18n/messages';
import { englishText } from '../utils/messageFallbacks';

const NAVIGATION_DEFINITIONS = {
  NAV_GET_STARTED: {
    id: 'nav.get_started',
    text: 'Get started',
    description: 'Get started navigation link text',
  },
  NAV_PRICING: {
    id: 'nav.pricing',
    text: 'Pricing',
    description: 'Pricing navigation link text',
  },
  NAV_DOCS: {
    id: 'nav.docs',
    text: 'Docs',
    description: 'Documentation navigation link text',
  },
  NAV_BLOG: {
    id: 'nav.blog',
    text: 'Blog',
    description: 'Blog navigation link text in the top nav bar. Leads to the article index at /blog.',
  },
  NAV_MCP: {
    id: 'nav.mcp',
    text: 'MCP',
    description: 'MCP Server navigation link text in top nav bar',
  },
  NAV_INTEGRATIONS: {
    id: 'nav.integrations',
    text: 'Integrations',
    description: 'Integrations navigation link text in top nav bar',
  },
  NAV_DASHBOARD: {
    id: 'nav.top_dashboard',
    text: 'Dashboard',
    description: 'Dashboard link in top navigation for logged-in users',
  },
  SPLIT_PANEL_PREFERENCES_TITLE: {
    id: 'nav.split_panel_preferences_title',
    text: 'Panel position',
    description: 'SplitPanel preferences dialog title',
  },
  SPLIT_PANEL_POSITION_LABEL: {
    id: 'nav.split_panel_position_label',
    text: 'Position',
    description: 'SplitPanel position label',
  },
  SPLIT_PANEL_POSITION_DESCRIPTION: {
    id: 'nav.split_panel_position_description',
    text: 'Choose where the panel opens',
    description: 'SplitPanel position description',
  },
  SPLIT_PANEL_POSITION_SIDE: {
    id: 'nav.split_panel_position_side',
    text: 'Side',
    description: 'SplitPanel side position option',
  },
  SPLIT_PANEL_POSITION_BOTTOM: {
    id: 'nav.split_panel_position_bottom',
    text: 'Bottom',
    description: 'SplitPanel bottom position option',
  },
  SPLIT_PANEL_CONFIRM: {
    id: 'nav.split_panel_confirm',
    text: 'Confirm',
    description: 'SplitPanel preferences confirm button',
  },
  SPLIT_PANEL_CANCEL: {
    id: 'nav.split_panel_cancel',
    text: 'Cancel',
    description: 'SplitPanel preferences cancel button',
  },
  SPLIT_PANEL_CLOSE_ARIA: {
    id: 'nav.split_panel_close_aria',
    text: 'Close panel',
    description: 'SplitPanel close button aria label',
  },
  SPLIT_PANEL_OPEN_ARIA: {
    id: 'nav.split_panel_open_aria',
    text: 'Open panel',
    description: 'SplitPanel open button aria label',
  },
  SPLIT_PANEL_RESIZE_ARIA: {
    id: 'nav.split_panel_resize_aria',
    text: 'Resize panel',
    description: 'SplitPanel resize handle aria label',
  },
};

export const NavigationComponentMessages = defineMessages(NAVIGATION_DEFINITIONS);

/** English fallbacks, used until `npm run i18n:extract` adds these ids to en-US.json. */
export const NavigationComponentText = englishText(NAVIGATION_DEFINITIONS);